/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type employees_EmployeePickerEntry = {
    /**
     * ClerkUserID is the opaque Clerk user id of the employee's login, the actor
     * key that created_by columns (workflow items, document versions, invoice
     * revisions) already carry. It lets a page name those actors. Omitted when
     * the employee has no login; it reveals no login state beyond that.
     */
    clerkUserId?: string;
    /**
     * Firstname is the employee's first name.
     */
    firstname: string;
    /**
     * GroupIDs are the ids of the employee's active group assignments. An
     * employee flagged all_groups belongs to every group whatever this lists.
     */
    groupIds: Array<string>;
    /**
     * ID is the employee id.
     */
    id: string;
    /**
     * Lastname is the employee's last name.
     */
    lastname: string;
    /**
     * Status is the derived employee status. DELETED rows are never returned.
     */
    status: employees_EmployeePickerEntry.status;
};
export namespace employees_EmployeePickerEntry {
    /**
     * Status is the derived employee status. DELETED rows are never returned.
     */
    export enum status {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
        UPCOMING = 'UPCOMING',
    }
}

